class mdlPlace {
    constructor(obj) {
        if (obj) {
            this.id = obj.id;
            this.name = obj.name;
            this.status = obj.status;
        }
        else {
            this.id = null;
            this.name = "";
            this.status = 0
        }
    }
}

class mdlTable {
    constructor(obj) {
        if (obj) {
            this.id = obj.id ?? 0;
            this.name = obj.name ?? "";
            this.placeId = obj.placeId ?? 0;
            this.chairs = obj.chairs ?? 0;
            this.svg = obj.svg ?? "0";
            this.type = obj.type ?? "1";
            this.positionX = obj.positionX ?? 0.0;
            this.positionY = obj.positionY ?? 0.0;
            this.status = obj.status ?? 0;
        } else {
            this.id = 0;
            this.name = "";
            this.placeId = 0;
            this.chairs = 0;
            this.svg = "0";
            this.type = "1";
            this.positionX = 0.0;
            this.positionY = 0.0;
            this.status = 0;
        }
    }
}

class mdlMenu {
    constructor(obj) {
        if (obj) {
            this.id = obj.id ?? 0;
            this.name = obj.name ?? "";
            this.status = obj.status ?? "";
        } else {
            this.id = 0;
            this.name = "";
            this.status = "";
        }
    }
}

export { mdlPlace, mdlTable, mdlMenu };